import axios from 'axios';
import Cookies from 'js-cookie';

const ApiClient = () => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
  });

  instance.interceptors.request.use(async (request) => {
    const rawSession = Cookies.get('token');

    if (rawSession) {
      const session = JSON.parse(rawSession);
      // @ts-ignore
      request.headers = {
        Authorization: `Bearer ${session?.user?.token}`,
      };
    }

    return request;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log(error);
      if (error.response && error.response.status === 401) {
        // Delete the session token cookie
        Cookies.remove('token');
        // Redirect to the home page
        window.location.href = '/';
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export default ApiClient();
